import { DEFAULT_NOT_BILLABLE_REASON } from "@/modules/common/billing/components/billing-form/constants"
import { getDeExistingBillingData } from "@/modules/common/billing/components/billing-form/de/libs/getDeExistingBillingData"
import { NotBillableReason, Service } from "@/types/__generated__/union-types"

export const getDeBillingDefaultValues = (
  appointment: {
    service: Service
  },
  billingAttribute: {
    readonly id: string
    readonly isNotBillable: boolean
    readonly isVisualSymptomExamination: boolean | null
    readonly notBillableReason: NotBillableReason | null
    readonly reason: string | null
  } | null,
) => {
  const isAdministrativeRequest = appointment.service === "ADMINISTRATIVE_REQUEST"
  const existingBillingData = getDeExistingBillingData(billingAttribute)

  if (existingBillingData) {
    return isAdministrativeRequest ? { ...existingBillingData, isNotBillable: false } : existingBillingData
  }

  return {
    isNotBillable: false,
    notBillableReason: DEFAULT_NOT_BILLABLE_REASON,
    reason: "",
  }
}
